// removed by extract-text-webpack-plugin
module.exports = {"Hamburger":"Hamburger__Hamburger__3u7Fp","HamburgerBar":"Hamburger__HamburgerBar__3GzuW","Open":"Hamburger__Open__1sBG9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Navbar/Hamburger/Hamburger.css
// module id = 74
// module chunks = 0